import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=ef836e38&lang=scss&scoped=true"

import exportComponent from "/Users/xiaozhi/Documents/codeWork/Vue/Vue项目/mighty_project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef836e38"]])

export default __exports__